import {
  ControlSectionContainer,
  LoadingSkeleton,
} from '@bloomfieldrobotics/canopy';
import { Typography } from '@mui/material';
import { useCustomer } from '../../../services/entities/hooks/useCustomer';
import { Customer } from '../../../services/entities/impl/blfApi/schemas/customer';
import { CustomerDropdown } from '../dropdowns/CustomerDropdown';

type EditableProps = {
  value: Customer['id'];
  editable: true;
  onChange: (newValue: Customer['id']) => void;
};

type ReadOnlyProps = {
  value: Customer['id'];
  editable?: false;
  onChange?: never;
};

type Props = EditableProps | ReadOnlyProps;

export const CustomerControlSection = (props: Props) => {
  const { value } = props;
  const { customer, isCustomerLoading } = useCustomer(value);

  return (
    <ControlSectionContainer>
      {props.editable ? (
        <CustomerDropdown value={value} onChange={props.onChange} fullWidth />
      ) : (
        <LoadingSkeleton loading={isCustomerLoading}>
          <Typography
            sx={{ fontWeight: 600, padding: 2, fontSize: '0.875rem' }}
          >
            {customer?.name}
          </Typography>
        </LoadingSkeleton>
      )}
    </ControlSectionContainer>
  );
};
